module.exports = __webpack_public_path__ + "static/media/S-5.b2410b9d.mp3";